const buildQueryString = (params) => {

    return '?' + Object.keys(params).map(key => params[key] === undefined ? undefined : `${key}=${params[key]}`)
        .filter(x => x !== undefined)
        .join('&');
};

export {

    buildQueryString,
}



// WEBPACK FOOTER //
// ./src/components/helpers/query.js